import React from 'react'

export default function PetfriendlyHead() {
  return (
    <>
    <section className="petpage-head">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-11">
                    <h1 className='heading'>Pet Friendly Resort in Jim Corbett</h1>
                    <p>Pet-friendly stays at De Coracao Resort make it easy to unwind without leaving your beloved companions behind. Nestled in a serene and scenic setting, the resort offers a warm and welcoming escape where well-behaved pets and their owners can enjoy peaceful surroundings, open spaces, and quality time together.</p>

                    <p>With comfortable accommodations and nature-filled walking areas nearby, pet-friendly stays at De Coracao Resort are designed to feel relaxed, effortless, and truly accommodating—whether you’re planning a short getaway or a longer stay immersed in comfort and calm.</p>
                </div>
            </div>
        </div>
    </section> 
    </>
  )
}
